import AjaxService from "services/base/Ajax.service";

class OrganizationService extends AjaxService {
  async getOrganization() {
    return this.get("/organization/");
  }

  async updateOrganization(data) {
    return this.post("/organization/update", data);
  }

  async deleteOrganization() {
    return this.delete("/organization/delete");
  }

  async createOrganization(data) {
    return this.post("/organization/create", data);
  }

  async getOrganizationResources() {
    return this.get("/organization/resources");
  }

  async getOrganizationSystems() {
    return this.get("/organization/systems");
  }

  async getOrganizationFiles() {
    return this.get("/organization/files");
  }

  async upsertOrganizationSystem(system, dependents, otherContactIds) {
    return this.post("/organization/system/upsert", {
      system,
      dependents,
      otherContactIds,
    });
  }

  async batchUpsertOrganizationSystemOtherContacts(organizationSystemId, data) {
    return this.post(
      `/organization/system/${organizationSystemId}/otherContacts/batchUpdate`,
      data,
    );
  }

  async deleteOrganizationSystem(systemId) {
    return this.delete(`/organization/system/${systemId}/delete`);
  }

  async getOrganizationSystemDependencies() {
    return this.get("/organization/system/dependencies");
  }

  async upsertOrganizationResource(data) {
    return this.post("/organization/resource/upsert", data);
  }

  async deleteOrganizationResource(resourceId) {
    return this.delete(`/organization/resource/${resourceId}/delete`);
  }

  async getHeartbeat() {
    return this.get("/config");
  }

  async requestOrganizationNameChange(data) {
    return this.post("/organization/request/name-change", data);
  }

  async requestOrganizationDeletion(data) {
    return this.post("/organization/request/deletion", data);
  }
}

export default new OrganizationService();
